import React, { Component } from "react"
import { Flex, Box } from "grid-styled"

import Logo from "../../img/milktea"

// eslint-disable-next-line
export default class Banner extends Component {
  render() {
    return (
      <Flex justifyContent={["center"]}>
        <Box p={3} w={[1 / 2, 1 / 3, 1 / 4, 1 / 5, 1 / 6]}>
          <Logo />
        </Box>
      </Flex>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Banner/index.js